<swal #currentSwal title="Operación" text="Operación realizada" icon="info"></swal>
<swal #notesSwal title="Operación" text="Operación realizada" icon="info"></swal>

<!-- <h1>{{fileIdValue ? fileIdValue: 'Sin id por ruta'}}</h1> -->
<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content">
	<div class="content-wrapper">
		<div class="content-header row mb-1"></div>
		<div class="content-detached">
			<div class="content-body">
				<!-- insertar barra de busqueda -->
				<app-search-bar [criterioPrincipal]="configLocal.barraBusqueda.criterioPrincipal" [config]="configLocal.barraBusqueda" (busqueda)="searchElementsByFilter($event)" [useAccordionMode]="true" [useInlineSearchButton]="true" [useInlineDeactivatedCheckbox]="true" [registroActivacion]="true" [filtroDteReferencias]="true" [dteReferencesCodesSource]="codeReferences" [filtroEstadoProveedor]="true" [filtroMultiple]="true"> </app-search-bar>
				<section class="row">
					<div class="col-12">
						<div class="card card-custom">
							<div class="card-header">
								<h4 class="card-title">{{ configLocal.table.title }}</h4>
							</div>
							<div class="card-head">
								<div class="heading-elements mt-0 btn-export">
									<button class="buttonMantenedor btn btn-warning float-right mr-5 mt-5" (click)="exportToExcel()" data-gtm-id="exportar" data-gtm-group="proveedores" *ngIf="permissions.getPermission('30-30-12').asignado" ngbTooltip="Utilice el filtro de búsqueda para acotar el rango a exportar">
										<i class="flaticon-download-1"></i>
										Exportar
									</button>
								</div>
								<!-- si no ha seleccionado proveedores aparecer un mensaje al hacer hover -->
								<div ngbDropdown>
									<button class="dropdownBotoneraLinea float-right mr-3 mt-5 buttonMantenedor btn btn-outline-primary" ngbDropdownToggle [disabled]="selected.length === 0" data-gtm-id="clasificar" data-gtm-group="proveedores" ngbTooltip="{{ selected.length === 0 ? 'Seleccione al menos un proveedor para clasificar' : '' }}">
										<fa-icon icon="user-shield" class="mr-2"></fa-icon>
										Clasificar proveedores
									</button>
									<div ngbDropdownMenu>
										<button class="buttonOption text-primary" ngbDropdownItem (click)="cambiarEstadoListaProveedores(ListaProveedorEnum.ListaBlanca)">
											<fa-icon icon="thumbs-up" class="mr-2"></fa-icon>
											Lista Blanca
										</button>
										<button class="buttonOption text-danger" ngbDropdownItem (click)="cambiarEstadoListaProveedores(ListaProveedorEnum.ListaNegra)">
											<fa-icon icon="thumbs-down" class="mr-2"></fa-icon>
											Lista Negra
										</button>
									</div>
								</div>

								<div>
									<button id="boton_agregar_proveedor" class="buttonMantenedor btn btn-success float-right mr-5 mt-5" data-gtm-id="crear" data-gtm-group="proveedores" (click)="addProveedorModal(addNewProveedorModal)" *ngIf="permissions.getPermission('30-30-10').asignado">
										<i class="flaticon-add-circular-button"></i>
										Agregar Proveedor
									</button>
								</div>
							</div>
							<div class="card-content">
								<div class="card-body">
									<!-- inicion seccion botones agregar y exportar -->
									<!-- <app-exportacion-datos [dataArray]="rowsMantenedor" [exportCriteria]="criteriosEnBase"></app-exportacion-datos> -->

									<!-- fin seccion botones -->

									<!-- seccion tabla -->
									<ngx-datatable
										#table
										class="material mobile-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="50"
										[rowHeight]="80"
										fxFlex="auto"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[selectionType]="'checkbox'"
										[selected]="selected"
										(selected)="onSelect($event)"
										[rowIdentity]="getId"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										(sort)="utilities.onSortTable(table, page)"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
										[externalSorting]="false"
										[sortType]="SortType.multi">
										<ngx-datatable-column [width]="40" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
											<ng-template ngx-datatable-header-template let-value="value">
												<input type="checkbox" class="customCheckbox" [checked]="selectedAllItemsInPage[page.pageNumber]" (change)="selectAll($event)" />
											</ng-template>

											<ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
												<input type="checkbox" class="customCheckbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="rutProveedor" [flexGrow]="2" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Rut</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{
													row.rutProveedor
														? row.rutProveedor
														: "No
                                       disponible"
												}}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="razonSocial" [flexGrow]="4" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Razón Social</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment text-wrap">{{
													row.razonSocial
														? row.razonSocial
														: "No
                                       disponible"
												}}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="DirFact" [flexGrow]="3" [sortable]="false" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Dirección Facturación</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment text-wrap" [ngbTooltip]="row.dirFact">{{
													row.dirFact
														? row.dirFact
														: "No
                                       disponible"
												}}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="ciudad" [flexGrow]="2.2" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Ciudad</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.ciudad ? row.ciudad : "No disponible" }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="Correo" [flexGrow]="3.2" [sortable]="false" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Correo</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment text-wrap" [ngbTooltip]="row.correoPar">{{
													row.correoPar
														? row.correoPar
														: "No
                                       disponible"
												}}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="Estado Lista" [flexGrow]="1.5" [sortable]="false" [resizeable]="false" [cellClass]="'icon-center-cell text-center'" [headerClass]="'text-center'">
											<ng-template ngx-datatable-header-template>
												<span class="text-table-alignment">Estado Lista</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row">
												<div class="d-flex justify-content-center align-items-center" style="height: 100%">
													<ng-container [ngSwitch]="row.listaProveedor">
														<fa-icon *ngSwitchCase="ListaProveedorEnum.ListaNegra" icon="thumbs-down" class="fa-lg text-danger" ngbTooltip="Proveedor en lista negra"></fa-icon>
														<fa-icon *ngSwitchCase="ListaProveedorEnum.ListaBlanca" icon="thumbs-up" class="fa-lg text-primary" ngbTooltip="Proveedor en lista blanca"> </fa-icon>
														<fa-icon *ngSwitchCase="ListaProveedorEnum.Desconocido" icon="question-circle" class="text-warning fa-lg" ngbTooltip="Proveedor desconocido"></fa-icon>
														<fa-icon *ngSwitchDefault icon="question-circle" class="text-muted fa-lg" ngbTooltip="Proveedor Desconocido"></fa-icon>
													</ng-container>
												</div>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="Acciones" [flexGrow]="4.5" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<a [routerLink]="" ngbTooltip="Detalles Proveedor" class="primary edit mr-1 mrless" id="mantenedor-proveedor.component_Detalles_Proveedor" (click)="detailModal(detailProvModal, row)" *ngIf="permissions.getPermission('30-30-14').asignado">
													<div class="icon-circle bg-warning text-center align-middle pt-info-button">
														<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a [routerLink]="" ngbTooltip="Editar Proveedor" class="primary edit mr-1 mrless" id="mantenedor-proveedor.component_Editar_Proveedor" (click)="editModal(editProveedorModal, row)" *ngIf="permissions.getPermission('30-30-16').asignado">
													<div class="icon-circle bg-info text-center align-middle pt-info-button">
														<fa-icon icon="pencil-alt" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a [routerLink]="" ngbTooltip="Reglas para Recepción de Documentos" placement="left" class="primary edit mr-1 mrless" (click)="rulesModal(proveedorRulesModal, row)">
													<div class="icon-circle bg-primary text-center align-middle pt-info-button">
														<fa-icon icon="cog" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a [routerLink]="" ngbTooltip="Desactivar Proveedor" class="primary edit mr-1 mrless" id="mantenedor-proveedor.component_Desactivar_Proveedor" *ngIf="row.activo && permissions.getPermission('30-30-20').asignado">
													<div
														class="icon-circle bg-danger text-center align-middle pt-info-button"
														[swal]="{
															title: 'Confirmación',
															text: '¿Está seguro que desea desactivar este Proveedor?',
															confirmButtonText: 'Sí, desactivar',
															cancelButtonText: 'Cancelar',
															showCancelButton: true,
															confirmButtonColor: '#3699FF',
															cancelButtonColor: '#f4516c'
														}"
														(confirm)="deactivateProvider(row)">
														<fa-icon icon="times-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a [routerLink]="" ngbTooltip="Activar Proveedor" class="primary edit mr-1 mrless" id="mantenedor-proveedor.component_Activar_Proveedor" *ngIf="!row.activo && permissions.getPermission('30-30-20').asignado">
													<div
														class="icon-circle bg-success text-center align-middle pt-info-button"
														[swal]="{
															title: 'Confirmación',
															text: '¿Está seguro que desea reactivar este Proveedor?',
															confirmButtonText: 'Sí, reactivar',
															cancelButtonText: 'Cancelar',
															showCancelButton: true,
															confirmButtonColor: '#3699FF',
															cancelButtonColor: '#f4516c'
														}"
														(confirm)="activateProvider(row)">
														<fa-icon icon="check-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<div ngbDropdown class="dropdownBotoneraLinea" container="body">
													<a container="body" ngbTooltip="Cambiar proveedor de lista" class="primary edit mr-1 mrless" ngbDropdownToggle id="dropdownEstadoLista">
														<div class="icon-circle bg-success text-center align-middle pt-info-button">
															<fa-icon icon="flag" class="fa-lg text-white"></fa-icon>
														</div>
													</a>

													<div ngbDropdownMenu aria-labelledby="dropdownEstadoLista">
														<button class="buttonOption" ngbDropdownItem *ngIf="row.listaProveedor !== ListaProveedorEnum.ListaBlanca" (click)="cambiarEstadoListaProveedores(ListaProveedorEnum.ListaBlanca, [row])">Pasar a lista blanca</button>
														<button class="buttonOption" ngbDropdownItem *ngIf="row.listaProveedor !== ListaProveedorEnum.ListaNegra" (click)="cambiarEstadoListaProveedores(ListaProveedorEnum.ListaNegra, [row])">Pasar a lista negra</button>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="col-auto">Elementos por página</div>
												<div class="mr-5">
													<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="datatable-footer">
														<option *ngFor="let option of page.pageSizes" [value]="option"></option>
													</ng-select>
												</div>
												<div class="ml-5 col-auto divisor-footer">
													<div class="page-count">{{ rowCount | number:'1.0-0':'es-CL' }} Elementos totales</div>
												</div>
												<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="table.onFooterPage($event)"> </datatable-pager>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
									<!-- fin seccion tabla seccion tabla -->

									<ngx-datatable
										#tableMobile
										*ngIf="componentStarted"
										class="material desktop-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="70"
										[rowHeight]="70"
										fxFlex="auto"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										[scrollbarH]="true"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }">
										<!-- Row Detail Template -->
										<ngx-datatable-row-detail [rowHeight]="70" #myDetailRow>
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
												<div class="text-wrap">
													Nombre: {{ row.razonSocial ? row.razonSocial : "No disponible" }} , Rut: {{ row.rutProveedor ? row.rutProveedor : "No disponible" }}, Correo: {{ row.correoPar ? row.correoPar : "No disponible" }}, Dirección Facturación: {{ row.dirFact ? row.dirFact : "No disponible" }} , Ciudad:
													{{
														row.ciudad
															? row.ciudad
															: "No
                                       disponible"
													}}
												</div>
											</ng-template>
										</ngx-datatable-row-detail>
										<ngx-datatable-column [width]="30" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
												<a [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" title="Expand/Collapse Row" (click)="toggleExpandRow(row)" class="desktop-hidden"> </a>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="Razón Social" [flexGrow]="6.5" [sortable]="false" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Proveedor</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{
													row.razonSocial
														? row.razonSocial
														: "No
                                       disponible"
												}}</span></ng-template
											>
										</ngx-datatable-column>

										<ngx-datatable-column name="Acciones" [flexGrow]="3" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<div class="action-container">
													<div class="main-action-button" (click)="toggleActions(row)" *ngIf="!row.showActions">
														<fa-icon [icon]="row.showActions ? 'minus' : 'list'"></fa-icon>
													</div>

													<div class="action-buttons action-buttons-client" id="action-buttons__Company" [ngClass]="{ show: row.showActions }">
														<a [routerLink]="" ngbTooltip="Detalles Proveedor" class="primary edit mr-1 mrless" id="mantenedor-proveedor.component_Detalles_Proveedor" (click)="detailModal(detailProvModal, row)" *ngIf="permissions.getPermission('30-30-14').asignado">
															<div class="icon-circle bg-warning text-center align-middle pt-info-button">
																<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a [routerLink]="" ngbTooltip="Editar Proveedor" class="primary edit mr-1 mrless" id="mantenedor-proveedor.component_Editar_Proveedor" (click)="editModal(editProveedorModal, row)" *ngIf="permissions.getPermission('30-30-16').asignado">
															<div class="icon-circle bg-info text-center align-middle pt-info-button">
																<fa-icon icon="pencil-alt" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a [routerLink]="" ngbTooltip="Reglas para Recepción de Documentos" placement="left" class="primary edit mr-1 mrless" (click)="rulesModal(proveedorRulesModal, row)">
															<div class="icon-circle bg-primary text-center align-middle pt-info-button">
																<fa-icon icon="cog" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="row" style="width: 100%">
													<div class="col-12 mb-2 ml-3 text-center mt-2">
														<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tableMobile.onFooterPage($event)"> </datatable-pager>
													</div>
													<div class="col-12 d-flex justify-content-center">
														<span class="mr-2 mt-3">Elementos por página</span>

														<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="body">
															<option *ngFor="let option of page.pageSizes" [value]="option"></option>
														</ng-select>
														<span class="ml-4 mt-3"> Página {{ curPage }} de {{ getTotalPages(rowCount, pageSize) }} </span>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</div>

<ng-template #detailProvModal let-d="dismiss" id="detail-modal">
	<div class="modal-content">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Detalles del Proveedor {{ proveedorToShow.razonSocial }}</div>
			</div>
		</div>
		<div class="modal-body">
			<div class="row form-group mx-auto" id="details-client">
				<div class="col-12">
					<div class="row">
						<div class="col-4">
							<span class="d-block">Rut</span>
							<span class="d-block">Razon Social</span>
							<span class="d-block">Giro</span>
							<span class="d-block">Ciudad</span>
							<span class="d-block">Comuna</span>
							<!-- <span class="d-block">Dirección Particular</span> -->
							<span class="d-block">Dirección de Facturación</span>
							<span class="d-block">Email</span>
							<span class="d-block">Casilla Dte Recibidos</span>
						</div>
						<div class="col-8">
							<span class="d-block text-right">{{
								proveedorToShow.rutProveedor
									? proveedorToShow.rutProveedor
									: "No
                        disponible"
							}}</span>
							<span class="d-block text-right">{{
								proveedorToShow.razonSocial
									? proveedorToShow.razonSocial
									: "No
                        disponible"
							}}</span>
							<span class="d-block text-right">{{
								proveedorToShow.giro
									? proveedorToShow.giro
									: "No
                        disponible"
							}}</span>
							<span class="d-block text-right">{{
								proveedorToShow.ciudad
									? proveedorToShow.ciudad
									: "No
                        disponible"
							}}</span>
							<span class="d-block text-right">{{
								proveedorToShow.comuna
									? proveedorToShow.comuna
									: "No
                        disponible"
							}}</span>
							<!-- <span class="d-block text-right">{{proveedorToShow.dirPart?proveedorToShow.dirPart:"No disponible"}}</span> -->
							<span class="d-block text-right">{{
								proveedorToShow.dirFact
									? proveedorToShow.dirFact
									: "No
                        disponible"
							}}</span>
							<span class="d-block text-right">{{
								proveedorToShow.correoPar
									? proveedorToShow.correoPar
									: "No
                        disponible"
							}}</span>
							<span class="d-block text-right">{{
								proveedorToShow.correoFact
									? proveedorToShow.correoFact
									: "No
                        asignada"
							}}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-success" data-dismiss="modal" (click)="d('Cross click')">Volver</button>
		</div>
	</div>
</ng-template>

<ng-template #addNewProveedorModal let-d="dismiss">
	<form (ngSubmit)="addProveedor(addForm)" #addForm="ngForm">
		<div class="modal-lg">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel1">Agregar Proveedor</h5>
				<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<!--Comentario -->
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Rut</label>
					<div class="col-9">
						<input
							type="text"
							name="newRut"
							placeholder="12.345.678-9"
							class="form-control"
							[ngClass]="{
								'is-invalid': rutProvedor.touched && rutProvedor.invalid
							}"
							#rutProvedor="ngModel"
							[(ngModel)]="newRut"
							maxlength="12"
							appVerificaRut
							appFormatRut
							required />
						<div *ngIf="rutProvedor.touched && rutProvedor.invalid" class="invalid-feedback-group">
							<div *ngIf="rutProvedor.errors?.required">Campo obligatorio</div>
							<div *ngIf="rutProvedor.errors?.rutNoValido" class="invalid-feedback-group">RUT Inválido</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Razon Social</label>
					<div class="col-9">
						<input
							type="text"
							[ngClass]="{
								'is-invalid': razonSocialProvedor.touched && razonSocialProvedor.invalid
							}"
							name="newRazonSocial"
							placeholder="Ingresar razon social"
							class="form-control"
							#razonSocialProvedor="ngModel"
							[(ngModel)]="newRazonSocial"
							required />
						<div *ngIf="razonSocialProvedor.invalid && razonSocialProvedor.touched" class="invalid-feedback-group">
							<div *ngIf="razonSocialProvedor.errors.required">Campo obligatorio</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Giro</label>
					<div class="col-9">
						<input
							type="text"
							name="newGiro"
							placeholder="Ingresa el giro del proveedor"
							class="form-control"
							#giroProvedor="ngModel"
							[ngClass]="{
								'is-invalid': giroProvedor.touched && giroProvedor.invalid
							}"
							[(ngModel)]="newGiro"
							required />
						<div *ngIf="giroProvedor.invalid && giroProvedor.touched" class="invalid-feedback-group">
							<div *ngIf="giroProvedor.errors.required">Campo obligatorio</div>
						</div>
					</div>
				</div>
				<!-- <div class="form-group row mx-auto" style="align-items: baseline">
                <label class="col-3 label-control" for="projectinput1">Dirección Particular</label>
                <div class="col-9">
                   <input
                      type="text"
                      name="newDirPart"
                      placeholder="Ingresa dirección particular del proveedor"
                      class="form-control"
                      #direccionParticularProvedor="ngModel"
                      [(ngModel)]="newDirPart"
                      [ngClass]="{
                         'is-invalid': !addForm.submitted && direccionParticularProvedor.invalid
                      }"
                      
                   />
                   <div *ngIf="!addForm.submitted && direccionParticularProvedor.invalid" class="invalid-feedback-group">
                      <div *ngIf="direccionParticularProvedor.errors.required">Campo obligatorio</div>
                   </div>
                </div>
             </div> -->
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Dirección Facturación</label>
					<div class="col-9">
						<input
							type="text"
							name="newDirFact"
							placeholder="Ingresa la dirección de facturación del proveedor"
							class="form-control"
							#direccionFacturacionProvedor="ngModel"
							[(ngModel)]="newDirFact"
							[ngClass]="{
								'is-invalid': !addForm.submitted && direccionFacturacionProvedor.invalid
							}" />
						<div *ngIf="!addForm.submitted && direccionFacturacionProvedor.invalid" class="invalid-feedback-group">
							<div *ngIf="direccionFacturacionProvedor.errors.required">Campo obligatorio</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Correo</label>
					<div class="col-9">
						<input
							type="email"
							name="newCorreoPart"
							placeholder="Ingresa el correo del proveedor"
							class="form-control"
							#correoProvedor="ngModel"
							[(ngModel)]="newCorreoPart"
							[ngClass]="{
								'is-invalid': correoProvedor.invalid && (correoProvedor.touched || addForm.submitted)
							}" />
						<div *ngIf="correoProvedor.invalid && (correoProvedor.touched || addForm.submitted)" class="invalid-feedback-group">
							<div *ngIf="correoProvedor.errors?.email">Correo no válido</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Ciudad</label>
					<div class="col-9">
						<input
							type="text"
							name="newCiudad"
							placeholder="Ingresa la ciudad del proveedor"
							class="form-control"
							#ciudadProvedor="ngModel"
							[(ngModel)]="newCiudad"
							[ngClass]="{
								'is-invalid': !addForm.submitted && ciudadProvedor.invalid
							}" />
						<div *ngIf="!addForm.submitted && ciudadProvedor.invalid" class="invalid-feedback-group">
							<div *ngIf="ciudadProvedor.errors.required">Campo obligatorio</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Comuna</label>
					<div class="col-9">
						<input
							type="text"
							name="newComuna"
							placeholder="Ingresa la comuna del proveedor"
							class="form-control"
							#comunaProvedor="ngModel"
							[(ngModel)]="newComuna"
							[ngClass]="{
								'is-invalid': !addForm.submitted && comunaProvedor.invalid
							}" />
						<div *ngIf="!addForm.submitted && comunaProvedor.invalid" class="invalid-feedback-group">
							<div *ngIf="comunaProvedor.errors.required">Campo obligatorio</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Correo para Envío de Documentos</label>
					<div class="col-9">
						<input
							type="email"
							name="newCasilla"
							placeholder="Ingresa el correo para envío de documentos"
							class="form-control"
							#casillaProvedor="ngModel"
							[(ngModel)]="newCasilla"
							[ngClass]="{
								'is-invalid': casillaProvedor.touched && casillaProvedor.invalid
							}"
							required />
						<!-- "(addForm.submitted && giroProvedor.invalid) || (giroProvedor.invalid && giroProvedor.touched)" -->
						<div *ngIf="casillaProvedor.invalid && casillaProvedor.touched" class="invalid-feedback-group">
							<div *ngIf="casillaProvedor.errors.required">Campo obligatorio</div>
							<div *ngIf="casillaProvedor.errors?.email">Correo no válido</div>
						</div>
						<!-- <div *ngIf="(giroProvedor.invalid && giroProvedor.touched)" class="invalid-feedback-group">
							<div *ngIf="giroProvedor.errors.required">Campo obligatorio</div>
						</div> -->
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="estadoListaProveedor">Estado Lista proveedor</label>
					<div class="col-9">
						<select id="estadoListaProveedor" name="newListaProveedor" class="form-control" [(ngModel)]="newListaProveedor" #estadoListaProveedor="ngModel" required>
							<option [ngValue]="null" disabled selected>Seleccione lista a la que desea agregar el proveedor</option>
							<ng-container *ngFor="let estado of estadoProveedorOptions">
								<option *ngIf="estado.descripcion !== 'Desconocido'" [ngValue]="estado.id">
									{{ estado.descripcion }}
								</option>
							</ng-container>
						</select>

						<div *ngIf="estadoListaProveedor.invalid && (estadoListaProveedor.touched || addForm.submitted)" class="invalid-feedback-group">
							<div>Campo obligatorio</div>
						</div>
					</div>
				</div>

				<div class="form-group row mx-auto" style="align-items: baseline">
					<label for="projectinput1" class="col-3 label-control">Reglas de recepción Estrictas</label>
					<input type="checkbox" [(ngModel)]="newAcuseReciboAutomatico" class="ml-5" name="newAcuseReciboAutomatico" #AcuseReciboAutomaticoProveedor="ngModel" />
				</div>
			</div>
			<div class="modal-footer">
				<alert id="alert-errormodal"></alert>
				<div class="form-group position-relative has-icon-left mb-0">
					<button [disabled]="addForm.invalid" type="submit" id="add-contact-item" class="btn btn-info add-contact-item">
						<i class="la la-paper-plane-o d-lg-none"></i>
						<span class="d-none d-lg-block">Guardar</span>
					</button>
				</div>
				<div class="form-group position-relative has-icon-left mb-0">
					<button type="button" class="btn btn-success" data-dismiss="modal" (click)="d('Cross click')">Volver</button>
				</div>
			</div>
		</div>
	</form>
</ng-template>

<ng-template #editProveedorModal let-d="dismiss">
	<form (ngSubmit)="editProveedor(addForm)" #addForm="ngForm">
		<div class="modal-lg">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel1">Actualizar Proveedor {{ proveedorToEdit.razonSocial }}</h5>
				<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<!--Comentario -->
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Rut</label>
					<div class="col-9">
						{{ proveedorToEdit.rutProveedor }}
					</div>
				</div>
				<!-- <div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Razon Social</label>
					<div class="col-9">
						{{ proveedorToEdit.razonSocial }}
					</div>
				</div> -->
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Razon Social</label>
					<div class="col-9">
						<input
							type="text"
							name="newRazonSocial"
							class="form-control"
							#razonSocialProvedor="ngModel"
							[(ngModel)]="proveedorToEdit.razonSocial"
							[ngClass]="{
								'is-invalid': !addForm.submitted && razonSocialProvedor.invalid
							}"
							required />
						<div *ngIf="!addForm.submitted && razonSocialProvedor.invalid" class="invalid-feedback-group">
							<div *ngIf="razonSocialProvedor.errors.required">Campo obligatorio</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Giro</label>
					<div class="col-9">
						<input
							type="text"
							name="newGiro"
							placeholder="Ingresa el giro del proveedor"
							class="form-control"
							#giroProvedor="ngModel"
							[(ngModel)]="proveedorToEdit.giro"
							[ngClass]="{
								'is-invalid': !addForm.submitted && giroProvedor.invalid
							}"
							required />
						<div *ngIf="!addForm.submitted && giroProvedor.invalid" class="invalid-feedback-group">
							<div *ngIf="giroProvedor.errors.required">Campo obligatorio</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Dirección Facturación</label>
					<div class="col-9">
						<input
							type="text"
							name="newDirFact"
							placeholder="Ingresa la dirección de facturación del proveedor"
							class="form-control"
							#direccionFacturacionProvedor="ngModel"
							[(ngModel)]="proveedorToEdit.dirFact"
							[ngClass]="{
								'is-invalid': !addForm.submitted && direccionFacturacionProvedor.invalid
							}" />
						<div *ngIf="!addForm.submitted && direccionFacturacionProvedor.invalid" class="invalid-feedback-group">
							<div *ngIf="direccionFacturacionProvedor.errors.required">Campo obligatorio</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Correo Contacto</label>
					<div class="col-9">
						<input
							type="email"
							name="newCorreoPart"
							placeholder="Ingresa el correo del proveedor"
							class="form-control"
							#correoProvedor="ngModel"
							[(ngModel)]="proveedorToEdit.correoPar"
							[ngClass]="{
								'is-invalid': correoProvedor.invalid && (correoProvedor.touched || addForm.submitted)
							}" />
						<div *ngIf="correoProvedor.invalid && (correoProvedor.touched || addForm.submitted)" class="invalid-feedback-group">
							<div *ngIf="correoProvedor.errors?.email">Correo no válido</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Ciudad</label>
					<div class="col-9">
						<input
							type="text"
							name="newCiudad"
							placeholder="Ingresa la ciudad del proveedor"
							class="form-control"
							#ciudadProvedor="ngModel"
							[(ngModel)]="proveedorToEdit.ciudad"
							[ngClass]="{
								'is-invalid': !addForm.submitted && ciudadProvedor.invalid
							}" />
						<div *ngIf="!addForm.submitted && ciudadProvedor.invalid" class="invalid-feedback-group">
							<div *ngIf="ciudadProvedor.errors.required">Campo obligatorio</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Comuna</label>
					<div class="col-9">
						<input
							type="text"
							name="newComuna"
							placeholder="Ingresa la comuna del proveedor"
							class="form-control"
							#comunaProvedor="ngModel"
							[(ngModel)]="proveedorToEdit.comuna"
							[ngClass]="{
								'is-invalid': !addForm.submitted && comunaProvedor.invalid
							}" />
						<div *ngIf="!addForm.submitted && comunaProvedor.invalid" class="invalid-feedback-group">
							<div *ngIf="comunaProvedor.errors.required">Campo obligatorio</div>
						</div>
					</div>
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="estadoListaProveedor">Estado Lista proveedor</label>
					<div class="col-9">
						<select id="estadoListaProveedorEditar" name="editListaProveedorId" class="form-control" [(ngModel)]="proveedorToEdit.listaProveedor" #estadoListaProveedorEdit="ngModel" required>
							<option *ngFor="let estado of estadoProveedorOptions" [ngValue]="estado.id">
								{{ estado.descripcion }}
							</option>
						</select>

						<div *ngIf="estadoListaProveedorEdit.invalid && (estadoListaProveedorEdit.touched || addForm.submitted)" class="invalid-feedback-group">
							<div>Campo obligatorio</div>
						</div>
					</div>
				</div>

				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Casilla para Envío de DTEs</label>
					<div class="col-9">
						<input
							type="email"
							name="newCasilla"
							placeholder="Ingresa el correo para envío de documentos"
							class="form-control"
							#casillaProvedor="ngModel"
							[(ngModel)]="proveedorToEdit.correoFact"
							[ngClass]="{
								'is-invalid': !addForm.submitted && casillaProvedor.invalid
							}"
							required />
						<div *ngIf="casillaProvedor.invalid && (casillaProvedor.touched || addForm.submitted)" class="invalid-feedback-group">
							<div *ngIf="casillaProvedor.errors.required">Campo obligatorio</div>
							<div *ngIf="casillaProvedor.errors?.email">Correo no válido</div>
						</div>
					</div>
				</div>
				<!-- <div class="form-group row mx-auto" style="align-items: baseline">
					<label for="projectinput1" class="col-3 label-control">Reglas de recepción Estrictas</label>
					<input type="checkbox" [(ngModel)]="proveedorToEdit.acuseReciboAutomatico" class="ml-4" name="editAcuseReciboAutomatico" #AcuseReciboAutomaticoProveedorEdit="ngModel" />
				</div> -->
			</div>
			<div class="modal-footer">
				<alert id="alert-errormodal"></alert>
				<div class="form-group position-relative has-icon-left mb-0">
					<button [disabled]="addForm.invalid" type="submit" id="add-contact-item" class="btn btn-info add-contact-item">
						<i class="la la-paper-plane-o d-lg-none"></i>
						<span class="d-none d-lg-block">Guardar</span>
					</button>
				</div>
				<div class="form-group position-relative has-icon-left mb-0">
					<button type="button" class="btn btn-success" data-dismiss="modal" (click)="d('Cross click')">Volver</button>
				</div>
			</div>
		</div>
	</form>
</ng-template>

<ng-template #proveedorRulesModal let-d="dismiss">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Configurar Reglas para Recepción de documentos</div>
				<div class="modal-wizard-desc">Indique los codigos de referencia y las etiquetas que debe traer XML recibido</div>
			</div>
		</div>
	</div>
	<div class="modal-body">
		<app-proveedor-rules-entry [relatedProveedor]="proveedorToShow" (sendCloseRequestEmitter)="closeRulesModal()" (sendRulesRequestEmitter)="sendRulesRequest($event)"></app-proveedor-rules-entry>
	</div>
</ng-template>
